import flow from 'lodash/flow'
import lowerCase from 'lodash/lowerCase'
import startCase from 'lodash/startCase'
import { RequiredDocumentStatus, RequiredDocumentType } from '~/types'
import { mapEnum } from './index'

export const StatusIcon: Record<RequiredDocumentStatus, { type: string; icon: string; class: string }> = {
  [RequiredDocumentStatus.SENT]: { type: 'is-success', icon: 'check-circle', class: 'has-text-success' },
  [RequiredDocumentStatus.PENDING_APPROVAL]: { type: 'is-warning', icon: 'alert-circle', class: 'has-text-warning' },
  [RequiredDocumentStatus.APPROVED]: { type: 'is-success', icon: 'check-circle', class: 'has-text-success' },
  [RequiredDocumentStatus.NOT_APPROVED]: { type: 'is-danger', icon: 'x-circle', class: 'has-text-danger' }
}

export const REQUIRED_DOCUMENTS_STATUS_OPTIONS = mapEnum(RequiredDocumentStatus, flow([lowerCase, startCase]))

export const REQUIRED_DOCUMENT_TYPE: Record<RequiredDocumentType, string> = {
  [RequiredDocumentType.DRAFT_BG_FORM]: 'Draft Bank Guarantee',
  [RequiredDocumentType.APPLICATION_FORM]: 'Application Form',
  [RequiredDocumentType.CUSTOMER_IDENTIFICATION]: 'Customer Identification Form',
  [RequiredDocumentType.FOR_CLIENT_RECORD]: 'For Applicants Records',
  [RequiredDocumentType.CERTIFIED_TRUST_DOCUMENT]: 'Certified Trust',
  [RequiredDocumentType.SHARE_CERTIFICATE]: 'Share Certificate',
  [RequiredDocumentType.OTHER_DOCUMENT]: 'Other Document'
}

export const REQUIRED_DOCUMENT_TYPE_ACTIONS: Record<RequiredDocumentType, string> = {
  [RequiredDocumentType.DRAFT_BG_FORM]: 'Review and Approve',
  [RequiredDocumentType.APPLICATION_FORM]: 'Sign',
  [RequiredDocumentType.CUSTOMER_IDENTIFICATION]: 'Complete',
  [RequiredDocumentType.FOR_CLIENT_RECORD]: '',
  [RequiredDocumentType.CERTIFIED_TRUST_DOCUMENT]: 'Requested',
  [RequiredDocumentType.SHARE_CERTIFICATE]: 'Requested',
  [RequiredDocumentType.OTHER_DOCUMENT]: 'Requested'
}

export const REQUIRED_DOCUMENT_TYPE_UPLOAD: Record<
  RequiredDocumentType,
  {
    assuroAdmin: boolean
    supplierAdmin: boolean
    applicant: boolean
  }
> = {
  [RequiredDocumentType.DRAFT_BG_FORM]: {
    assuroAdmin: true,
    supplierAdmin: false,
    applicant: false
  },
  [RequiredDocumentType.APPLICATION_FORM]: {
    assuroAdmin: true,
    supplierAdmin: true,
    applicant: true
  },
  [RequiredDocumentType.CUSTOMER_IDENTIFICATION]: {
    assuroAdmin: true,
    supplierAdmin: true,
    applicant: true
  },
  [RequiredDocumentType.FOR_CLIENT_RECORD]: {
    assuroAdmin: true,
    supplierAdmin: true,
    applicant: false
  },
  [RequiredDocumentType.CERTIFIED_TRUST_DOCUMENT]: {
    assuroAdmin: false,
    supplierAdmin: false,
    applicant: true
  },
  [RequiredDocumentType.SHARE_CERTIFICATE]: {
    assuroAdmin: false,
    supplierAdmin: false,
    applicant: true
  },
  [RequiredDocumentType.OTHER_DOCUMENT]: {
    assuroAdmin: false,
    supplierAdmin: false,
    applicant: true
  }
}
